import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '../../provider/main.service';
import { ApiUrls } from '../../config/api-urls/api-urls';

@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {

  resetPassword: FormGroup | any;
  resetId: any;

  constructor(private activatedRoute: ActivatedRoute, public mainService: MainService, public router: Router) { }

  ngOnInit() {
    this.resetPassword = new FormGroup({
      "password": new FormControl('', ([Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/)])),
      "confirmPassword": new FormControl('', [Validators.required])
    });
    this.activatedRoute.params.subscribe((res) => {
      this.resetId = res.id
    })
  }

  resetApi() {
    if (this.resetPassword.valid) {
      const data = {
        userId: this.resetId,
        password: this.resetPassword.value.password,
        confirmPassword: this.resetPassword.value.confirmPassword,
      }
      this.mainService.showSpinner()
      this.mainService.putApi(ApiUrls.resetPassword, data, 0).subscribe((res: any) => {
        if (res.responseCode == 200) {
          this.mainService.hideSpinner();
          this.mainService.successToast(res.responseMessage)
          // this.resetId = res.result;
          this.router.navigateByUrl('/login')
        } else {
          this.mainService.hideSpinner();
          this.mainService.errorToast(res.responseMessage)
        }
      }, (err) => {
        this.mainService.hideSpinner()
      })
    }
    else {
      this.mainService.errorToast('Email is required.')
    }
  }

}
